import validator from 'validator';
import { shoorahBenefitsPageData as mainPageData } from '../utils/pageContent';

export const AddCustomPlansBenefitsValidation = (data) => {
  const pageData = mainPageData.addCustomBenefitsPageData;
  const errors = {};

  if (validator.isEmpty(data?.name?.trim())) {
    errors.name = pageData.nameRequriedtext;
  }

  if (data?.email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emails = data?.email?.split(',').map((email) => email.trim());
    const invalidEmails = emails.filter((email) => email && !regex.test(email));
    if (invalidEmails.length > 0) {
      errors.email = pageData.invalidEmailAddressMessage;
    }
  } else {
    errors.email = pageData.emailIsRequriedMessage;
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};
